// extracted by mini-css-extract-plugin
export default {"wrapper":"CallToAction_wrapper__jlOc4","cta-desc":"CallToAction_cta-desc__vzWcF","cta-btn":"CallToAction_cta-btn__Etava"};